import './Contact.css';

const Contact = () => {
  return (
    <section className="contact" id="contacto">
      <div className="contact-container">
        <div className="section-number contact-number">04 — Contacto</div>
        <h2 className="contact-title">¿Tenés un proyecto en mente?</h2>
        <p className="contact-description">
          Estoy abierta a oportunidades freelance, colaboraciones y posiciones full-time.
        </p>

        <div className="contact-buttons">
          <a href="mailto:emily83_d@hotmail.com" className="contact-btn contact-btn-primary">
            ✉ tu-email@gmail.com
          </a>
          <a
            href="https://www.linkedin.com/in/emilse-d%C3%ADaz-fullstack/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn contact-btn-secondary"
          >
            in LinkedIn
          </a>
          <a
            href="https://github.com/Emilsediaz"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn contact-btn-secondary"
          >
            ⌥ GitHub
          </a>
        </div>
      </div>

      <footer className="footer">
        <p>© {new Date().getFullYear()} Emilse Diaz · Hecho con React</p>
      </footer>
    </section>
  );
};

export default Contact;
